import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.dataLayer !== "object") return;
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
}
